'use client';

import React from 'react';

const Loading = () => {
  return (
    <div className='fixed inset-0 w-full h-screen flex items-center justify-center bg-background z-[9999]'>
      <div className='flex flex-col items-center gap-4'>
        <div className='h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent'></div>
        <div className='animate-pulse text-foreground'>Loading...</div>
      </div>
    </div>
  );
};

export default Loading;
